import RetencionesInfoStore from './RetencionesInfoStore';
import RetencionesListStore from './RetencionesListStore';
import RetencionesCreateStore from './RetencionesCreateStore';
import RetencionesCancelStore from './RetencionesCancelStore';
import RetencionesDownloadStore from './RetencionesDownloadStore';

const RetencionesStore = {
  list: RetencionesListStore,
  info: RetencionesInfoStore,
  cancel: RetencionesCancelStore,
  creation: RetencionesCreateStore,
  download: RetencionesDownloadStore,
};

export default RetencionesStore;
